/* eslint-disable camelcase */
export default class SalesStatus {
  constructor (data) {
    this.id = data.id
    this.retailName = data.retail_name
    this.lastSales = data.last_sales
    this.connectionStatus = this.getConnectionStatus(data.b_status)
    this.unmappedProductsCount = data.count_product_not_mapped
    this.incidentDescription = data.incident_description
  }

  getConnectionStatus (bStatus) {
    if (!bStatus) return 'OK'

    if (bStatus === 'Clave Bloqueada' ||
        bStatus.includes('Token API expirado') ||
        bStatus.includes('Token API inválido')) {
      return bStatus
    }

    return 'OK'
  }

  get isConnectionError () {
    return this.connectionStatus !== 'OK'
  }

  get connectionStatusClass () {
    return this.isConnectionError ? 'text-danger' : 'text-success'
  }

  get formattedLastSales () {
    if (!this.lastSales) return 'Sin registro'
    return this.lastSales
  }

  static fromArray (data) {
    return data.map(item => new SalesStatus(item))
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/SalesStatus.js